// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-card[data-v-069d20b0]{\n  width: 155px !important;\n}\n.avatarHeight[data-v-069d20b0]{\n  height: 135px;\n  width: 135px ;\n}\n", ""]);
// Exports
module.exports = exports;
